import React from 'react';
import './App.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import Home from './components/Home/Home';
import About from './components/About/About';
import Tutor from './components/Tutor/Tutor';
import NotFound from './components/NotFound/NotFound';
import Aids from './components/Aids/Aids';
import { BrowserRouter as Router, Switch, Route } from 'react-router-dom';
import Header from './components/Header/Header';
import Footer from './components/Footer/Footer';

function App() {
  return (
    <div className="body-color">
      {/* Router starts here */}
      <Router>
        <Header></Header>
        <Switch>
          <Route path="/home">
            <Home></Home>
          </Route>
          <Route exact path="/">
            <Home></Home>
          </Route>
          <Route path="/aids">
            <Aids></Aids>
          </Route>
          <Route path="/about">
            <About></About>
          </Route>
          <Route path="/tutor">
            <Tutor></Tutor>
          </Route>
          <Route path="*">
            <NotFound></NotFound>
          </Route>
        </Switch>
        <Footer></Footer>
      </Router>
    </div>
  );
}

export default App;
